import axios from "axios";
import dayjs from "dayjs";

const encodeForm = (data) => {
  return Object.keys(data)
    .map((key) => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&");
};

export const submitContactForm = async (body) => {
  try {
    const { data } = await axios.post("/contact-us", encodeForm(body), {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });

    return data;
  } catch (err) {
    throw new Error("Something went wrong");
  }
};

export const subscribeNewsletter = async (body) => {
  try {
    const { data } = await axios.post("/api/newsletter", body);

    return data;
  } catch (err) {
    throw new Error("Something went wrong");
  }
};

export const getInArticleBanner = async (lang) => {
  const url = "https://wp-api.zipmex.com/wp-json/wp/v2/in-article-banners";

  const getMetaValue = (lang) =>
    ({
      en: ".com",
      au: ".com.au",
      id: ".co.id",
      th: ".co.th",
    }[lang.split("_")[0]]);

  try {
    const { data } = await axios.get(url, {
      params: {
        meta_key: "gc_link_to",
        meta_value: getMetaValue(lang),
      },
    });

    return data[0]?.banners || null;
  } catch (err) {
    throw new Error("Something went wrong");
  }
};

export const getTickersSummary = async (ticker, currencies) => {
  const url = "https://public-api.zipmex.net/api/v1.0/summary/";

  const res = {};

  try {
    const {
      data: { data },
    } = await axios.get(url);

    currencies.forEach((currency) => {
      const pairData = data[`${currency}_${ticker}`];
      if (pairData) {
        res[currency] = pairData;
      }
    });

    return res;
  } catch (err) {
    throw new Error("Something went wrong");
  }
};

const filterInprogressCoin = (coins) => {
  return coins.filter((coin) => {
    return dayjs(coin.earningEndedAt).diff(dayjs()) > 0;
  });
};

export const getInProgressCoin = async (lang) => {
  const countryCode = (lang) =>
    ({
      en: "global",
      au: "au",
      id: "id",
      th: "th",
    }[lang.split("_")[0]]);

  try {
    const { data } = await axios({
      url: "https://api.zipmex.net/graphql/",
      method: "post",
      data: {
        query: `
          query {
            zLaunch {
              pools(product: "zipmex", countryCode: "${countryCode(lang)}") {
                nextOffset
                entries {
                  poolId
                  poolLockProduct {
                    id
                    name
                    symbol
                    decimalPlaces
                  }
                  poolLockedAmount
                  rewardProduct {
                    id
                    name
                    symbol
                    decimalPlaces
                  }
                  rewardTotalAmount
                  earningStartedAt
                  earningEndedAt
                  estimatedApy
                }
              }
            }
          }
        `,
      },
    });
    const pools = data.data.zLaunch.pools.entries;
    if (pools) {
      if (pools.length) {
        const inprogressCoin = filterInprogressCoin(
          data.data.zLaunch.pools.entries
        );
        return inprogressCoin;
      }
    }
    return undefined;
  } catch (err) {
    throw new Error("Something went wrong");
  }
};

export const getZLaunchCoin = async (country, ticker) => {
  try {
    const { data } = await axios({
      url: "https://api.zipmex.net/graphql/",
      method: "post",
      data: {
        query: `
          query {
            zLaunch {
              pools(product: "zipmex", countryCode: "${country}") {
                entries {
                  rewardProduct {
                    symbol
                    decimalPlaces
                  }
                  poolLockProduct {
                    symbol
                  }
                  earningStartedAt
                  earningEndedAt
                  rewardTotalAmount
                  poolCapAmount
                  userCapAmount
                }
              }
            }
          }
        `,
      },
    });

    return data.data.zLaunch.pools.entries.filter(
      (pool) => pool.rewardProduct.symbol === ticker
    );
  } catch (err) {
    throw new Error("Something went wrong");
  }
};
